<template>
  <div class="guide">
    <Tooltip content="新手引导" placement="bottom">
      <Button type="text">
        <Icon type="ios-help-circle-outline" :size="23" @click.native.stop="guide"></Icon>
      </Button>
    </Tooltip>
  </div>
</template>
<script>
import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'
import steps from './steps'
import { mapActions } from 'vuex'
export default {
  name: 'Guide',
  data () {
    return {
      driver: null,
      count: 0
    }
  },
  mounted () {
    this.driver = new Driver({
      className: 'scoped-class', // className to wrap driver.js popover
      animate: true, // Animate while changing highlighted element
      opacity: 0.75, // Background opacity (0 means only popovers and without overlay)
      padding: 10, // Distance of element from around the edges
      allowClose: true, // Whether clicking on overlay should close or not
      overlayClickNext: false, // Should it move to next step on overlay click
      doneBtnText: '完成', // Text on the final button
      closeBtnText: '关闭', // Text on the close button for this step
      nextBtnText: '下一步', // Next button text for this step
      prevBtnText: '上一步' // Previous button text for this step
      // Called when moving to next step on any step
    })
    const count = this.$store.state.userManage.loginCount
    this.count = count
    if (count === 0) {
      setTimeout(() => {
        this.guide()
        this.editLoginCount()
      }, 1000)
    }
  },
  methods: {
    ...mapActions([
      'editUser'
    ]),
    guide () {
      this.driver.defineSteps(steps)
      this.driver.start()
    },
    editLoginCount () {
      const id = this.$store.state.user.userId
      const count = this.count + 1
      const data = {id: id, loginCount: count}
      this.editUser(data).then(res => {
      })
    }
  }
}
</script>
<style lang="less">
  .guide{
    margin-right: 5px;
    .ivu-badge-dot{
      top: 20px;
    }
    .ivu-btn.ivu-btn-text{
      padding: 5px 1px 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/components/guide/index.vue